// import contrast from 'get-contrast';

import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CalendarIcon = ({
  marginLeft,
  marginRight,
  color = 'foraBlue',
  title,
  width = 13,
  containerSize,
}: DefaultIconProps) => {
  return (
    <DefaultIconWrapper
      marginLeft={marginLeft}
      marginRight={marginRight}
      containerSize={containerSize}
      width={width}
      title={title}
    >
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0125 3H18.5C19.875 3 21 4.125 21 5.5V18.5C21 19.875 19.875 21 18.5 21H3.5C2.125 21 1 19.875 1 18.5V5.5C1 4.125 2.125 3 3.5 3H5V1.75C5 1.3375 5.3375 1 5.75 1H7.2625C7.675 1 8.0125 1.3375 8.0125 1.75V3H14.0125V1.6C14.0125 1.2625 14.2875 1 14.6125 1H16.4125C16.75 1 17.0125 1.275 17.0125 1.6V3ZM17.7625 19.5C18.45 19.5 19.0125 18.9375 19.0125 18.25V8.5H3.0125V18.25C3.0125 18.9375 3.575 19.5 4.2625 19.5H17.7625ZM7.51257 11.6625C7.51257 12.4875 6.83757 13.1625 6.01257 13.1625C5.18757 13.1625 4.51257 12.4875 4.51257 11.6625C4.51257 10.8375 5.18757 10.1625 6.01257 10.1625C6.83757 10.1625 7.51257 10.8375 7.51257 11.6625ZM11.0126 13.1625C11.8376 13.1625 12.5126 12.4875 12.5126 11.6625C12.5126 10.8375 11.8376 10.1625 11.0126 10.1625C10.1876 10.1625 9.51257 10.8375 9.51257 11.6625C9.51257 12.4875 10.1876 13.1625 11.0126 13.1625ZM7.51257 15.9875C7.51257 16.8125 6.83757 17.4875 6.01257 17.4875C5.18757 17.4875 4.51257 16.8125 4.51257 15.9875C4.51257 15.1625 5.18757 14.4875 6.01257 14.4875C6.83757 14.4875 7.51257 15.1625 7.51257 15.9875ZM11.0126 17.4875C11.8376 17.4875 12.5126 16.8125 12.5126 15.9875C12.5126 15.1625 11.8376 14.4875 11.0126 14.4875C10.1876 14.4875 9.51257 15.1625 9.51257 15.9875C9.51257 16.8125 10.1876 17.4875 11.0126 17.4875ZM17.5126 11.6625C17.5126 12.4875 16.8376 13.1625 16.0126 13.1625C15.1876 13.1625 14.5126 12.4875 14.5126 11.6625C14.5126 10.8375 15.1876 10.1625 16.0126 10.1625C16.8376 10.1625 17.5126 10.8375 17.5126 11.6625Z"
          fill={getSemanticTextColor(color)}
        />
      </svg>
    </DefaultIconWrapper>
  );
};
